module.exports = __webpack_public_path__ + "assets/img/5.ceb1491a.png";